import Layout from '@/components/global/Layout';
import SEO from '@/components/global/SEO';
import HeroSection from '@/components/Pages/Filiais/HeroSection';
import PageContent from '@/components/Pages/Filiais/PageContent';
import ConhecaADelps from '@/components/global/ConhecaADelps';

import { PageWrapper, PageContainer, SectionWrapper } from '@/styles/Page';
import { ConhecaADelpsWrapper } from '@/styles/Pages/filiais';

import api from '@/services/graphCMS';
import { GetStaticProps } from 'next';

interface IFiliais {
  filiais: {
    endereco: string;
    id: string;
    email: string;
    estado: string;
    slug: string;
    telefone: string;
    cidadesAtendidas: {
      nome: string;
    }[];
    diasAtivosEntrega: string[];
    nome: string;
    iframeMaps: string;
    imagemMaps: {
      url: string;
    };
    linkLocalizacao: string;
  }[];
}

const Filiais = ({ filiais }: IFiliais): JSX.Element => {
  return (
    <>
      <SEO title="Filiais" description="Filiais da Delps" />
      <Layout>
        <PageWrapper>
          <PageContainer>
            <SectionWrapper>
              <HeroSection />
            </SectionWrapper>
            <SectionWrapper>
              <PageContent filiais={filiais} />
            </SectionWrapper>
            <ConhecaADelpsWrapper>
              <ConhecaADelps />
            </ConhecaADelpsWrapper>
          </PageContainer>
        </PageWrapper>
      </Layout>
    </>
  );
};

export default Filiais;

export const getStaticProps: GetStaticProps = async () => {
  const { data } = await api.post('', {
    query: `query{
      filiais {
        endereco
        email
        estado
        slug
        telefone
        cidadesAtendidas{
          nome
        }
        diasAtivosEntrega
        nome
        iframeMaps
        id
        imagemMaps{
          url
        }
        linkLocalizacao
      }
    }`,
  });

  return {
    props: { filiais: data.data.filiais },
    revalidate: 10000,
  };
};
